(function (app) {
    app.constant("genders",
    [
        "Male",
        "Female",
        "Other"
    ]);
})(window.app); //jshint ignore:line